// Minhas tarefas: todas as linhas de bancos de dados em que a pessoa está
// numa coluna do tipo Pessoa, com status e prazo, de todos os quadros.

import * as router from "./router.js";
import { api } from "./api.js";
import { el, fmtDate, relTime, safeGet, safeSet } from "./dom.js";
import { iconNode, ui } from "./icons.js";

const DONE = /(conclu|aprovad|done|feito|arquiv|cancel|entregue|finaliz)/i;

export async function renderTasks(host) {
  const list = el("div", { class: "tasks-list" }, el("p", { class: "muted" }, "Carregando…"));
  let show = safeGet("ordo.tasksFilter", "open");
  let tasks = [];
  const tabs = el("div", { class: "picker-tabs" });
  const today = new Date().toISOString().slice(0, 10);
  const info = (t) => {
    const props = t.database.schema?.properties || [];
    const status = props.find((p) => ["select", "status"].includes(p.type) && /status|etapa|situa/i.test(p.name)) || props.find((p) => p.type === "status");
    const due = props.find((p) => p.type === "date" && /prazo|entrega|venc|due|data/i.test(p.name)) || props.find((p) => p.type === "date");
    const sv = status ? t.props[status.id] : null;
    const color = status?.options?.find((o) => o.name === sv)?.color || "gray";
    const id = props.find((p) => p.type === "id");
    return { status: sv, color, due: due ? t.props[due.id] : null, done: sv ? DONE.test(sv) : false, code: id && t.seq ? `${id.prefix ? id.prefix + "-" : ""}${t.seq}` : null };
  };
  const draw = () => {
    tabs.replaceChildren(...[["open", "Em aberto"], ["late", "Atrasadas"], ["all", "Todas"]].map(([id, l]) =>
      el("button", { class: "picker-tab" + (show === id ? " on" : ""), onclick: () => { show = id; safeSet("ordo.tasksFilter", id); draw(); } }, l)));
    const rows = tasks.map((t) => ({ t, i: info(t) }))
      .filter(({ i }) => show === "all" || (!i.done && (show === "open" || (i.due && String(i.due).slice(0, 10) < today))))
      .sort((a, b) => (a.i.due ? String(a.i.due) : "9999").localeCompare(b.i.due ? String(b.i.due) : "9999") || b.t.updated_at - a.t.updated_at);
    const groups = new Map();
    for (const r of rows) {
      const k = r.t.database.id;
      if (!groups.has(k)) groups.set(k, { db: r.t.database, rows: [] });
      groups.get(k).rows.push(r);
    }
    list.replaceChildren(...(rows.length ? [...groups.values()].map((g) => el("section", { class: "tasks-group" },
      el("button", { class: "tasks-db", onclick: () => router.openPage(g.db.id) }, iconNode(g.db.icon, "▦"), " ", g.db.title || "Sem título",
        el("span", { class: "muted small" }, ` · ${g.rows.length}`)),
      g.rows.map(({ t, i }) => el("button", { class: "task-item" + (i.done ? " done" : ""), onclick: () => router.openPage(t.id) },
        i.code ? el("span", { class: "task-code" }, i.code) : null,
        el("span", { class: "task-title" }, t.title || "Sem título"),
        el("span", { class: "grow" }),
        i.status ? el("span", { class: `chip c-${i.color}` }, i.status) : null,
        i.due ? el("span", { class: "task-due" + (!i.done && String(i.due).slice(0, 10) < today ? " late" : String(i.due).slice(0, 10) === today ? " today" : "") }, ui("calendar", 13), " ", fmtDate(String(i.due).slice(0, 10))) : null,
        el("span", { class: "muted small task-when" }, relTime(t.updated_at))))))
      : [el("div", { class: "inbox-empty" }, el("div", { class: "inbox-empty-icon" }, ui("tasks", 40)),
        el("p", {}, show === "late" ? "Nenhuma tarefa atrasada." : "Nenhuma tarefa com você. Quando alguém colocar seu nome numa coluna de pessoa (DEV, QA, Responsável…), ela aparece aqui."))]));
  };
  host.replaceChildren(el("div", { class: "list-view" }, el("h1", {}, ui("tasks", 26), " Minhas tarefas"), tabs, list));
  try {
    tasks = (await api("GET", "/my-tasks")).tasks;
    draw();
  } catch (err) {
    list.replaceChildren(el("p", { class: "error" }, err.message));
  }
}
